/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".spacer[_ngcontent-%COMP%] {\r\n    margin-left: 5px;\r\n}"];
export { styles as styles };
